import React from "react";
import { vibesColors as colors } from "../../theme/vibesColors";

export default function MissingClubConfig() {
  return (
    <div className="container py-5 px-3 text-center" style={{ color: colors.textColor }}>
      <p className="mb-0">
        Set{" "}
        <code style={{ color: colors.violate }}>REACT_APP_DEFAULT_HOST_ID</code>{" "}
        (or <code style={{ color: colors.violate }}>REACT_APP_DEFAULT_CLUB_ID</code>) or open{" "}
        <code style={{ color: colors.violate }}>/club/&lt;hostId&gt;</code>
      </p>
    </div>
  );
}
